// Theme.js - Main theme JavaScript file
// This file is required for Shopify themes to function properly

(function () {
    'use strict';

    // Initialize theme when DOM is ready
    document.addEventListener('DOMContentLoaded', function () {
        // Theme initialization code can go here
        console.log('Theme initialized');
    });

    // Handle theme editor mode
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
            // Handle section reloads in theme editor
        });
    }
})(); 